import React, { useEffect, useState } from 'react';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.css';
import Navbar from './Navbar';

function ChangePassword() {
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [error, setError] = useState('');
    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [link, setLink] = useState('');
    const[linkText, setLinkText] = useState('');
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        checkLogin();
    }, []);

    async function checkLogin() {
        try {
            await Auth.currentAuthenticatedUser();
            setIsLoggedIn(true);
            
         } catch {
            console.log('in fileuploadform: User not signed in');
            setIsLoggedIn(false);
            navigate('/login');
        }
    }
    useEffect(() => {
        
        if (isLoggedIn){
            console.log('Logged in');
            setLink('/logout');
            setLinkText('Logout');    
        }else{
            console.log('Not logged in');
            setLink('/login');
            setLinkText('Login');   

        }
    }, [isLoggedIn]);

    const navigate = useNavigate();

    const toggleOldPasswordVisibility = () => {
        setShowOldPassword(!showOldPassword);
    };

    const toggleNewPasswordVisibility = () => {
        setShowNewPassword(!showNewPassword);
    };

    const toggleConfirmPasswordVisibility = () => { 
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleChangePassword = async (event) => {
        event.preventDefault();
        if (newPassword !== confirmNewPassword) {
            setError('New passwords do not match!')
            return;
        }

        try {
            const user = await Auth.currentAuthenticatedUser();
            console.log(user);
            const changePassword = await Auth.changePassword(user, oldPassword, newPassword);
            console.log(changePassword);

            alert('Password changed successfully!');
            navigate('/mainmenu');
            // Redirect or perform other actions after successful password change
        } catch (error) {
            console.error('Error changing password: ', error);
            setError('Error changing passwords');
        }
    };


    return (
        <div className="flex-container-1">                  
        <div className="upload-container">
            

            <Navbar link={link} linkText={linkText}/>
            

            <form className="login-form-spacer" onSubmit={handleChangePassword}>

            <div className="upload-text-container">
                <div className="changepassword-title-text">Change Password</div>
                
            </div>


                <div className="login-question-container">
                    <label className="login-label">Old Password</label>
                    <div className="password-wrapper">
                        <input 
                            value={oldPassword}
                            onChange={(event) => setOldPassword(event.target.value)}
                            type={showOldPassword ? "text" : "password"}
                            
                        />
                        <button tabIndex="-1" type="button" className="toggle-password" onClick={toggleOldPasswordVisibility}>{showOldPassword ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}</button>
                    </div>
                </div>  

                <div className="login-question-container">
                    <label className="login-label">New Password</label>
                    <div className="password-wrapper">
                        <input 
                            value={newPassword}
                            onChange={(event) => setNewPassword(event.target.value)}
                            type={showNewPassword ? "text" : "password"}
                        />
                        <button tabIndex="-1" type="button" className="toggle-password" onClick={toggleNewPasswordVisibility}>{showNewPassword ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}</button>
                    </div>
                </div>

                <div className="login-question-container">
                    <label className="login-label">Confirm New Password</label>
                    <div className="password-wrapper">
                        <input 
                            value={confirmNewPassword}
                            onChange={(event) => setConfirmNewPassword(event.target.value)}
                            type={showConfirmPassword ? "text" : "password"}
                        />
                        <button tabIndex="-1" type="button" className="toggle-password" onClick={toggleConfirmPasswordVisibility}>{showConfirmPassword ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}</button>
                    </div>
                </div>

                {error && (
                <div className="login-question-container">
                    <label className="login-error-message">{error}</label>
                    </div>
                
                )}

                    <div className="login-button-container">
                            <button className="login-submit-button" type="submit">Change Password</button>
                    </div>
    
                </form>
              </div>

              

        </div>
     
    );
}

export default ChangePassword;
